import { CSSProperties } from 'react';

export type DragNDropAndResizableType = {
  id: string; // Уникальный id окна
  isOpened: boolean; // Открыто ли окно
  container: (props?: any) => JSX.Element; // Компонент-обертка всего окна для гибкой стилизации
  onClose: (props?: any) => void; // Функция закрытия окна
  headerLeft: JSX.Element; // Контент левой части заголовка окна, за которую его можно таскать
  body: JSX.Element; // Контент окна

  // дефолтные параметры указаны ниже (переменная defaults)

  width?: number; // ширина окна px
  height?: number; // высота окна px
  top?: number; // координата top окна px
  left?: number; // Координата left окна px
  zIndexWrrapper?: number; // zIndex  wrapper'а окна
  zIndex?: number; // zIndex окна относительно wrapper'а
  minWidth?: number; // минимальная ширина окна
  minHeight?: number; // минимальная высота окна
  resizePaddings?: number; // отступы от окна, когда можно менять его размер px
  sx?: CSSPropertiesOmitted; // дополнительный css

  onChange?: (props: OnChangeProps) => void;
};

export const ON_CHANGE_REASON = {
  MOVEMENT: 'movement',
  RESIZE: 'resize',
  TO_FULL_SCREEN: 'toFullScreen',
  FROM_FULL_SCREEN: 'fromFullScreen',
} as const;

export type OnChangeReason = (typeof ON_CHANGE_REASON)[keyof typeof ON_CHANGE_REASON];

export type OnChangeProps = {
  top: number;
  left: number;
  width: number;
  height: number;
  changed: OnChangeReason;
};

export type CSSPropertiesOmitted = Omit<
  CSSProperties,
  'width' | 'height' | 'top' | 'left' | 'zIndex' | 'bottom' | 'right'
>;

export const defaults = {
  width: 600,
  height: 400,
  top: 10,
  left: 10,
  zIndexWrrapper: 10000,
  zIndex: 10,
  minWidth: 400,
  minHeight: 300,
  resizePaddings: 32,
};

export type resizeData = {
  movement: number;
  direction: -1 | 1;
};

export type Cursors =
  | 'ew-resize'
  | 'ns-resize'
  | 'nesw-resize'
  | 'nwse-resize'
  | 'inherit';
